import { HeaderContextType } from '@types/HeaderContextType.types';
import { createContext } from 'react';

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export default HeaderContext;
